import { useCallback } from 'react';
import { useLocation } from 'react-router';

import type { HtmlElementWithSrc } from '../types/HtmlElementWithSrc';

import { isHtmlVideoElement } from '../utils/isHtmlVideoElement';
import { rewriteUrl } from '../utils/rewriteUrl';

export const useSrcRewriter = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  return useCallback(
    (srcElement: HtmlElementWithSrc) => {
      const src = srcElement.getAttribute('src');

      if (!src || src.startsWith('http')) {
        return;
      }

      // rewrite relative links to be absolute
      const newSrc = rewriteUrl(src, currentPath);

      srcElement.setAttribute('src', newSrc);

      const parent = srcElement.parentElement;
      if (isHtmlVideoElement(parent)) {
        parent.load();
      }
    },
    [currentPath],
  );
};
